module.exports = __webpack_public_path__ + "static/media/chevron-left.153054ba.svg";